import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { QuestionAnswerJson } from '@core/models/built/session-step-value-json.model';
import { SessionStep } from '@core/models/session.model';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  templateUrl: './input-true-false-multi-report.component.html'
})
export class InputTrueFalseMultiReportComponent implements OnChanges {

  @Input() step!: SessionStep;

  private step$$ = new BehaviorSubject<SessionStep>(this.step);
  step$ = this.step$$.asObservable();

  values$ = this.step$.pipe(map(step => step.values?.map(v => v.value as QuestionAnswerJson) || []));

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.step) {
      this.step$$.next(changes.step.currentValue);
    }
  }
}
